var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticStyle:{"z-index":"3"},attrs:{"app":"","color":"background","text":"","flat":"","prominent":"","absolute":"","dense":""}},[_c('app-logo',{attrs:{"app":""}}),_c('app-menu'),_c('v-spacer'),_c('app-account-switcher')],1)}
var staticRenderFns = []

export { render, staticRenderFns }